import { ToneDto } from '../tonedto';

export interface SearchToneDto
{
    getLanguage():string;
    getSearchKey():string;
    getArtistKey():string;
    getCategoryId():number;
    getSortBy():string;
    getAlignBy():string;
    getPageNo():number;
    getSearchLanguage():string;
    getPagePerCount():number;
    getToneId(): string;
    //getCount():number;
    //getSearchList() : SearchToneDetailsDto[];
    getListOfTones(): ToneDto[];
}

export class SearchToneDtoImpl implements SearchToneDto
{
    private toneId: string;
    private language: string;
    private searchKey: string;
    private artistKey: string;
    private categoryId: number;
    private sortBy: string;
    private alignBy: string;
    private pageNo: number;
    private searchLanguage: string;
    private pagePerCount: number;
    //private count: number;
    //private searchList: SearchToneDetailsDto[];
    private searchList: ToneDto[];


    setToneId(toneId: string): void
    {
        this.toneId = toneId;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string
    {
        return this.language;
    }

    getSearchKey(): string
    {
        return this.searchKey;
    }
    setSearchKey(searchKey: string)
    {
        this.searchKey = searchKey;
    }

    getArtistKey(): string
    {
        return this.artistKey;
    }
    setArtistKey(artistKey: string)
    {
        this.artistKey = artistKey;
    }

    getToneId(): string
    {
        return this.toneId;
    }

    getCategoryId(): number
    {
        return this.categoryId;
    }
    setCategoryId(categoryId: number)
    {
        this.categoryId = categoryId;
    }

    getSortBy(): string
    {
        return this.sortBy;
    }
    setSortBy(sortBy: string)
    {
        this.sortBy = sortBy;
    }

    getAlignBy(): string
    {
        return this.alignBy;
    }
    setAlignBy(alignBy: string)
    {
        this.alignBy = alignBy;
    }

    getPageNo(): number
    {
        return this.pageNo;
    }
    setPageNo(pageNo: number)
    {
        this.pageNo = pageNo;
    }

    setSearchLanguage(searchLanguage: string)
    {
        this.searchLanguage = searchLanguage;
    }
    getSearchLanguage(): string 
    {
        return this.searchLanguage;
    }   

    getPagePerCount(): number
    {
        return this.pagePerCount;
    }
    setPagePerCount(pagePerCount: number)
    {
        this.pagePerCount = pagePerCount;
    }
     
    getListOfTones(): ToneDto[]
    {
        return this.searchList;
    }
    setListOfTones(searchList: ToneDto[])
    {
        this.searchList = searchList;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/searchtone/searchtonedto.ts